import { Link, useLocation } from "react-router-dom";
import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { telLink, whatsappLink } from "@/data/business";

export function MobileBottomNav() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-white border-t border-gray-100 shadow-[0_-4px_24px_rgba(15,61,94,0.08)]"
      data-testid="mobile-bottom-nav"
      aria-label="Quick actions"
    >
      <div className="grid grid-cols-3">
        <a
          href={telLink}
          className="flex flex-col items-center justify-center gap-1 py-3 text-navy active:bg-neutralbg transition-colors"
          data-testid="bottomnav-call"
        >
          <Phone className="w-5 h-5" />
          <span className="text-xs font-semibold">Call Now</span>
        </a>
        <a
          href={whatsappLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center gap-1 py-3 text-brandgreen-dark active:bg-neutralbg transition-colors border-x border-gray-100"
          data-testid="bottomnav-whatsapp"
        >
          <MessageCircle className="w-5 h-5" />
          <span className="text-xs font-semibold">WhatsApp</span>
        </a>
        <Link
          to="/quote"
          className="flex flex-col items-center justify-center gap-1 py-3 bg-brandgreen text-white active:bg-brandgreen-dark transition-colors"
          data-testid="bottomnav-quote"
        >
          <CalendarCheck className="w-5 h-5" />
          <span className="text-xs font-semibold">Get Quote</span>
        </Link>
      </div>
    </nav>
  );
}
